/*************************************************/
/* STICKY SIDEBAR                                */
/*************************************************/

import StickySidebar from 'sticky-sidebar/dist/sticky-sidebar';

export function stickySidebar() {

    var init = function () {

        const sidebar = document.getElementById('siteGridLayoutLeft');
        if ($(sidebar).length > 0) {
            var stickySidebar = new StickySidebar(sidebar,
                {
                    containerSelector: ".site-grid-layout",
                    innerWrapperSelector: ".menu-subnav__wrap",
                    topSpacing: 175,
                    resizeSensor: true,
                });


            var intervalCounter = 0;
            var resizeInterval = setInterval(function() {
                window.dispatchEvent(new Event('resize'));
                console.log("her");
                if (intervalCounter === 4) {
                    window.clearInterval(resizeInterval);
                }

                },
                1000);

        }
    };

    init();
}